// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CloseRunCurrencyBucket } from '@/accounting/api/types';
import { IsoCurrencyCode } from '@/currency/constants/iso';

/** Adds the isoCode that PerCurrencySections keys on to each close run currency bucket. */
export function toPerCurrencySectionBuckets(
  buckets: CloseRunCurrencyBucket[]
): (CloseRunCurrencyBucket & { isoCode: IsoCurrencyCode })[] {
  // PerCurrencySections keys each section on `isoCode`, but a close run bucket names the same
  // code `currency`, so each bucket carries both until one name is settled in
  // https://github.com/hardfinhq/hardfin/issues/15916.
  return buckets.map((bucket) => ({ ...bucket, isoCode: bucket.currency }));
}
